import Article from '@components/views/article/Article';
import Cards from '@components/views/cards/Content';
import Header from '@components/views/header/Header';
import Hero from '@components/views/hero/Hero';
import Floater from '@components/views/floater/Floater';
import Footer from '@components/views/footer/Footer';
import { ACFProvider } from '@context/ACFContext';
import { useVideoEmbeds } from '@utils/useVideoEmbeds';
import React from 'react';

function App() {
	useVideoEmbeds();
	return (
		<React.Fragment>
			<ACFProvider>
				<Header />
				<Hero />
				<Cards />
				<Article />
				<Floater />
				<Footer />
			</ACFProvider>
		</React.Fragment>
	);
}

export default App;
